import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { apiJson } from "../../utils/api";
import { Disclaimer } from "./MarriageLayout";
import useSeo from "../../hooks/useSeo";

export default function MarriageHome() {
  const [data, setData] = useState(null);
  useSeo({
    title: "领证中心 | AI婚姻第一站",
    metaDescription: "查询结婚登记政策与附近婚姻登记处，体验模拟领证、婚前问答与婚后生活模拟。非正式婚姻登记。",
    path: "/marriage",
  });

  useEffect(() => {
    apiJson("/api/marriage/home")
      .then(({ data: d }) => setData(d))
      .catch(() => setData({ modules: [] }));
  }, []);

  const modules = data?.modules || [];

  return (
    <div className="space-y-8">
      <section className="text-center space-y-3">
        <p className="text-sm tracking-widest text-rose-500">AI婚姻第一站</p>
        <h1 className="text-3xl md:text-4xl font-extrabold">💍 领证中心</h1>
        <p className="text-gray-600 max-w-2xl mx-auto">
          从“我们是不是该结婚了”开始：查政策、找登记点、模拟领证、谈分歧，再决定要不要走进民政局。
        </p>
        <Disclaimer className="max-w-2xl mx-auto text-left" />
      </section>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {modules.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className="bg-white rounded-2xl p-5 shadow-sm border border-rose-100 hover:-translate-y-0.5 transition"
          >
            <div className="text-2xl mb-2">{item.icon}</div>
            <h2 className="font-bold">{item.title}</h2>
            <p className="text-sm text-gray-500 mt-1">{item.desc}</p>
          </Link>
        ))}
      </div>

      <section className="bg-white rounded-2xl p-6 border border-rose-100 space-y-3">
        <h3 className="font-bold">怎么用情侣纪念码</h3>
        <ol className="text-sm text-gray-600 list-decimal pl-5 space-y-1">
          <li>打开「模拟领证」，填写网站里的男方/女方昵称（登录后会带入你的资料），生成 LOVE- 开头的纪念码。</li>
          <li>也可以登录后在婚前问答/婚后模拟页点「用我的账号创建」，名称来自你的会员资料。</li>
          <li>把纪念码发给另一半。婚前100问、婚后模拟必须用同一串码，双方分别点「男方/女方」作答。</li>
          <li>「我的领证日」跟网站登录账号绑定，登录即可保存倒计时，纪念码可选用。</li>
        </ol>
        <p className="text-sm text-gray-600">
          建议路径：婚前问答 → 模拟领证 → 婚后模拟 → 查政策与地点 → 保存领证日 → 婚礼与蜜月。
          真实政务信息带来源和核验时间；模拟体验绝不冒充法律登记。
        </p>
      </section>
    </div>
  );
}
